import { FormattedMessage } from 'react-intl';
import { typographyClasses } from '@mui/material';
import ListItemText from '@mui/material/ListItemText';
import { RotatingIcon } from '@atoms/icons';
import { Flex } from '@atoms/layout';
import { NavListItemButton, NavListItemButtonProps } from '@molecules/navigation';

type SettingsMenuItemProps = NavListItemButtonProps & {
  opened?: boolean;
  hasChildren?: boolean;
  titleKey: string;
};
export function SettingsMenuItem({ hasChildren = false, titleKey, opened = false, ...props }: SettingsMenuItemProps) {
  return (
    <NavListItemButton
      disableHighlight={hasChildren}
      activeSx={{
        [`& .${typographyClasses.root}`]: {
          fontWeight: 'bold',
        },
      }}
      {...props}
    >
      <Flex
        justifyContent="space-between"
        width="100%"
        alignCenter
        gap={1}
        // Reserve place for the icon when there are no children
        pr={hasChildren ? 0 : 4}
      >
        <ListItemText primary={<FormattedMessage id={`settings.menu.${titleKey}.title`} />} />
        {hasChildren && (
          <RotatingIcon activeAngle={-180} inactiveAngle={0} active={opened} name="chevron-down" variant="light" />
        )}
      </Flex>
    </NavListItemButton>
  );
}
